<template>
  <app-panel class="employee-consistency-reports">
    <vs-collapse accordion class="employee-consistency-reports__collapse">
      <vs-collapse-item v-for="(report, reportIndex) in reports" :key="reportIndex">
        <div slot="header">
          {{report.text}} ({{report.values.length}})
        </div>

        <div>
          <vs-table :data="report.values" hoverFlat :pagination="report.values.length > 20" max-items="20"
                    class="employee-consistency-reports__table">
            <template slot="thead">
              <vs-th style="width: 1%" v-for="(value, title) in report.values[0]" :key="`table-title-${title}`">{{title}}</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="`table-row-${trIndex}`" v-for="(tr, trIndex) in data">
                <vs-td v-for="(value, valueIndex) in tr" :key="`${trIndex}-${valueIndex}`">{{value}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-collapse-item>
    </vs-collapse>
  </app-panel>
</template>

<script>
  export default {
    name: "ConsistencyReports",
    data() {
      return {
        reports: [],
      }
    },
    computed: {
      selectedHouseId() {
        return this.$store.getters['appUser/selectedHouse'].id;
      }
    },
    methods: {
      async getConsistencyReport() {
        try {
          let {data} = await this.$http.get('get_consistency_report', {
            params: {
              buildings_id: this.selectedHouseId
            }
          });
          this.reports = data;
        } catch (e) {
          console.error(e);
          this.reports = [];
        }
      },
      async updateConsistencyReport() {
        try {
          await this.$http.put('start_consistency_report', {
            buildings_id: this.selectedHouseId
          });
          this.getConsistencyReport();
        } catch (e) {
          console.error(e);
        }
      }
    },
    created() {
      this.updateConsistencyReport();
      this.getConsistencyReport();
    }
  }
</script>

<style lang="scss">
  .employee-consistency-reports {

    &__collapse{
      padding: 0;
    }

    &__table {
      .vs-table--tbody {
        border: none;
        background: #fff;
      }

      .vs-table--thead th {
        padding: 0 !important;
        border-bottom: 1px solid rgba(0, 0, 0, .125);

        .vs-table-text {
          text-align: left;
          position: relative;
          vertical-align: bottom;
          padding: .75rem 10px;
          background: transparent;
          font-size: 12px;
        }
      }

      .vs-table {
        .vs-table--tr:nth-child(2n+1) {
          background: #f5f8fa;
        }
      }

      .tr-values td {
        padding: .5rem 10px;
        font-size: 12px;
      }

      .vs-table--pagination .vs-pagination--mb {
        justify-content: center !important;
      }
    }
  }
</style>
